/* import __COLOCATED_TEMPLATE__ from './phone-save-or-cancel.hbs'; */
/* RESPONSIBLE TEAM: team-fin-voice */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    section: string;
    onSave: () => void;
    onCancel: () => void;
    savingDisabled?: boolean;
    disabledTooltipContent?: string;
  };
}

const PhoneSaveOrCancel = templateOnlyComponent<Signature>();
export default PhoneSaveOrCancel;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Operator::Fin::Setup::Sections::NumberConfiguration::PhoneSaveOrCancel': typeof PhoneSaveOrCancel;
  }
}
